// TODO use these in editor/viewer apps
export const BEHAVIORS = {
  saveFailureFeedback: {
    name: 'saveFailureFeedback',
    label: 'Connect_Panel_Form_Messages_Option_Submit_Fail',
    textElement: `<p class="font_8"><span style="color:#FF4040">An error occurred. Try again later</span></p>`,
  },
  saveSuccessFeedback: {
    name: 'saveSuccessFeedback',
    label: 'Connect_Panel_Form_Messages_Option_Submit_Success',
    textElement: `<p class="font_8">Your content has been submitted</p>`,
  },
}
